<div class="canvas-image" [class.has-overlay]="this.hasOverlay === true" [class.open]="this.showOverlay === true" (click)="toggleOverlay()">
  <canvas #canvasElement style="max-width: 100%; height: auto;"></canvas>
</div>

